import { AxiosError } from 'axios';

import { LINKS_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { Link } from '@/types/link.type';
import { ApiResponse } from '@/types/response.type';

const getLinks = async (): Promise<ApiResponse<Link[]>> => {
  try {
    const response = await apiManager.get(LINKS_API_URL, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default getLinks;
